import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { Star } from 'lucide-react';
import 'swiper/css';
import 'swiper/css/pagination';


const testimonios = [
    {
        nombre: "Romina",
        rating: 5,
        texto: "Me pasó el contacto de Glowin un compañero de mi trabajo, los chicos vinieron hasta mi domicilio en horario cabe descatacar, son muy limpios y ordenados, quedé muy conforme y contenta con su servicio brindado, además no te piden ni conectar el agua, son totalmente auto sustentables. Los recomiendo totalmente. Gracias Glowin."
    },
    {
        nombre: "Pedro",
        rating: 5,
        texto: "Honestamente sin palabras, se nota que es una empresa totalmente seria y que les gusta lo que hacen, me dejaron mi Corolla reluciente y ni siquiera me tuve que mover de mi casa. Son unos genios, además de todo lo mencionado me dejaron un regalo para el auto, sin duda los volveré a llamar."
    },
    {
        nombre: "Agustín",
        rating: 5,
        texto: "Son unos genios, los llamé por el lavado Luxury y me trabajaron todo el auto, me lo dejaron como si lo hubiera sacado del concesionario. La verdad no tengo nada negativo para decirles, no solo te lavan el auto si no que te explican también qué productos usan para que uno se informe. Unos fenomenos totalmente recomendable."
    },
    {
        nombre: "Patricia",
        rating: 5,
        texto: "Con mi marido volvimos de la costa y teníamos el auto en muy mal estado, decidimos contactarnos con Glowin, sacamos un turno y los chicos vinieron a nuestro domicilio. Nos dejaron la camioneta impecable sin ir más lejos los mejores, la atención y la predispocición que tienen es bárbara y encima nos dejaron regalos y aromatizadores para que quede con rico olor nuestra camioneta. Gracias Glowin !!!"
    },
];

const Testimonials: React.FC = () => {
    return (
        <section className="container mx-auto px-4 py-8 text-white">
            <div className="container mx-auto max-w-[90rem] px-4 sm:px-6 lg:px-8">
                <div className="mb-16 text-center">
                    <h2 className="text-4xl font-bold text-white">Testimonios de nuestros clientes</h2>
                </div>

                {/* Desktop Grid */}
                <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 p-3">
                    {testimonios.map((testimonio, index) => (
                        <div key={index} className="bg-gray-800 rounded-lg p-6 shadow-lg flex flex-col h-full w-full">
                            <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-yellow-500 text-gray-900 text-2xl font-bold">
                                {testimonio.nombre.charAt(0)}
                            </div>
                            <h5 className="text-white font-medium text-lg mb-2">{testimonio.nombre}</h5>
                            <div className="flex mb-4">
                                {[...Array(testimonio.rating)].map((_, i) => (
                                    <Star key={i} className="w-5 h-5 fill-current text-yellow-500" />
                                ))}
                            </div>
                            <p className="text-gray-300 flex-grow">{testimonio.texto}</p>
                        </div>
                    ))}
                </div>

                {/* Mobile Carousel */}
                <div className="md:hidden">
                    <Swiper
                        spaceBetween={16}
                        slidesPerView={1}
                        modules={[Pagination]}
                        pagination={{ clickable: true }}
                    >
                        {testimonios.map((testimonio, index) => (
                            <SwiperSlide key={index}>
                                <div className="bg-gray-800 rounded-lg p-6 shadow-lg flex flex-col h-full w-full">
                                    <div className="flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-yellow-500 text-gray-900 text-2xl font-bold">
                                        {testimonio.nombre.charAt(0)}
                                    </div>
                                    <h5 className="text-white font-medium text-lg mb-2">{testimonio.nombre}</h5>
                                    <div className="flex mb-4">
                                        {[...Array(testimonio.rating)].map((_, i) => (
                                            <Star key={i} className="w-5 h-5 fill-current text-yellow-500" />
                                        ))}
                                    </div>
                                    <p className="text-gray-300 flex-grow">{testimonio.texto}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
